import { Order } from "@types-runway/case";

const shippedStatuses = ["out_for_delivery", "completed"];

const isActive = (order: Order) => order.status !== "cancelled";

const isShipped = (order: Order) => shippedStatuses.includes(order.status);

// Whether an Order further down the chain of replacements of this one is active.
const hasActiveSuccessor = (order: Order, orders: Order[]) => {
  const visitedIds = new Set([order.id]);
  let next = orders.find((other) => other.id === order.supersededByOrderId);

  while (next && !visitedIds.has(next.id)) {
    if (isActive(next)) return true;

    visitedIds.add(next.id);
    next = orders.find((other) => other.id === next?.supersededByOrderId);
  }

  return false;
};

// Two Orders paid by different invoices are each charged on their own, as a deferred remainder is;
// an Order with no invoice could duplicate any other (REDOUI-R82).
const isPaidSeparately = (order: Order, other: Order) =>
  Boolean(order.invoiceId && other.invoiceId && order.invoiceId !== other.invoiceId);

// The Orders of the alert for a second active Order, newest first. The Orders that count are the
// active Orders, except an Order that shipped and is answered by an active Order of its chain
// (REDOUI-R64); of those, the alert names each that conflicts with another (REDOUI-R82, R83).
export const findConflictingOrders = (orders: Order[]): Order[] => {
  const counting = orders.filter(
    (order) => isActive(order) && !(isShipped(order) && hasActiveSuccessor(order, orders))
  );
  const conflicting = counting.filter((order) =>
    counting.some((other) => other !== order && !isPaidSeparately(order, other))
  );

  return [...conflicting].sort((first, second) => second.id - first.id);
};
